/*
 * Filename: form-control-configuration-panel.component.tsx
 * Description: Page section holds fields level configuration information
 */

import React, { Component, ReactNode } from 'react';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { GridHeaderStdVisibilityRuletModal } from '../header-actions/std-visibility-rule-modal.component';
import { CQAppStore } from '../../../../../store/cq-app-store';
import GridTemplateConfigurationController from '../../grid-template-config.controller';
import { AppliedRuleGridComponent } from '../../grid-applied-rule.component';
import { GridActionsReducer } from '../action-controller/grid-actions.reducer';
import { ActionMapperController } from '../action-controller/action-mapper';
import GridRightPaneComponentName from './grid-right-pane-component-name';

export class StandardHeaderActionComponent
    extends Component<{ selectedTemplateName: string, action: any }, {
        isApplyRuleModalVisisble: boolean, name: string, label: string, isFormValid: boolean, componentName: string, actionType: string, isRuleApplied: boolean, isActionSaved: boolean
        visibilityRuleObj: any, visibilityRuleFields: any, isVisible: string, additionalFieldsArray: any
    }> {

    private gridController: GridTemplateConfigurationController;
    private gridActionsReducer: GridActionsReducer;
    private componentList: any;
    constructor(props: Readonly<{ selectedTemplateName: string, action: any }>) {
        super(props);
        this.gridController = new GridTemplateConfigurationController();
        this.gridActionsReducer = new GridActionsReducer();
        this.state = {
            isApplyRuleModalVisisble: false,
            componentName: '',
            name: '',
            label: '',
            isFormValid: false,
            actionType: 'standard_header_action',
            isRuleApplied: false,
            visibilityRuleObj: {},
            isActionSaved: false,
            visibilityRuleFields: [],
            isVisible: '',
            additionalFieldsArray: [],
        };
    }
    componentDidMount() {
        const selectedAction = CQMasterDataStore.GridObject.selectedHeaderAction;
        const ruleElements: any = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const headerActions = gridObj.hasOwnProperty('headerActions') ? gridObj.headerActions : {};

        if (headerActions.hasOwnProperty(selectedAction.name.developerName)) {
            const ruleObject: any = { ...headerActions[selectedAction.name.developerName] };
            this.setState({
                isApplyRuleModalVisisble: ruleObject.isApplyRuleModalVisisble,
                name: ruleObject.name,
                label: ruleObject.label,
                componentName: ruleObject.componentName,
                isFormValid: ruleObject.isFormValid,
                isActionSaved: ruleObject.isActionSaved,
                isRuleApplied: ruleObject.isRuleApplied,
                visibilityRuleObj: ruleObject.visibilityRuleObj,
                visibilityRuleFields: ruleObject.visibilityRuleFields,
                isVisible: ruleObject.isVisible,
                additionalFieldsArray: ruleObject.additionalFieldsArray,
            });
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps && nextProps.action.name.developerName !== this.props.action.name.developerName) {
            const selectedAction = CQMasterDataStore.GridObject.selectedHeaderAction;
            const ruleElements: any = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
            const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
            const headerActions = gridObj.hasOwnProperty('headerActions') ? gridObj.headerActions : {};
            if (headerActions.hasOwnProperty(selectedAction.name.developerName)) {
                const ruleObject: any = { ...headerActions[selectedAction.name.developerName] }
                this.setState({
                    isApplyRuleModalVisisble: ruleObject.isApplyRuleModalVisisble,
                    name: ruleObject.name,
                    label: ruleObject.label,
                    componentName: ruleObject.componentName ? ruleObject.componentName : '',
                    isFormValid: ruleObject.hasOwnProperty('isFormValid') ? ruleObject.isFormValid : false,
                    isActionSaved: ruleObject.hasOwnProperty('isActionSaved') ? ruleObject.isActionSaved : false,
                    isRuleApplied: ruleObject.hasOwnProperty('isRuleApplied') ? ruleObject.isRuleApplied : false,
                    visibilityRuleObj: ruleObject.visibilityRuleObj ? ruleObject.visibilityRuleObj : {},
                    visibilityRuleFields: ruleObject.visibilityRuleFields ? ruleObject.visibilityRuleFields : [],
                    isVisible: ruleObject.hasOwnProperty('isVisible') ? ruleObject.isVisible : false,
                    additionalFieldsArray: ruleObject.hasOwnProperty('additionalFieldsArray') && ruleObject.additionalFieldsArray.length ? ruleObject.additionalFieldsArray : [],
                });
            }
        }
    }

    public render(): ReactNode {
        const selectedHeaderAction = CQMasterDataStore.GridObject.selectedHeaderAction;
        const ruleObject: any = this.extractStoreData(selectedHeaderAction);
        return (
            <>
                <div className="slds-col config-sidebar full-height">
                    <div className="bg-white full-height slds-p-around_small">
                        <div className="slds-grid slds-grid_vertical full-height">
                            <h2 className="slds-text-heading_small slds-m-bottom_medium">Header Actions</h2>
                            <dl className="slds-dl_horizontal slds-m-bottom_medium">
                                <dt className="slds-dl_horizontal__label">Standard Action</dt>
                            </dl>
                            <div className="slds-grid slds-grid_vertical full-height scroll-content">
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Name</label>
                                    <div className="slds-form-element__control">
                                        <input disabled={true} type="text" id="" placeholder="Add Name"
                                            value={selectedHeaderAction.name.developerName === 'New' ? `std_new` : `std_new_${(selectedHeaderAction.name.developerName).toLowerCase()}`}
                                            className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Label</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Label"
                                            value={selectedHeaderAction.name.name === 'New' ? 'New' : `New ${selectedHeaderAction.name.name}`} disabled={true}
                                            className="slds-input" />
                                    </div>
                                </div>
                                <GridRightPaneComponentName
                                    isDisabled= {false}
                                    onSelect= {this.onComponentNameChange}
                                    actionType= {this.state.actionType}
                                    key= "standardRowAction"
                                    value= {this.state.componentName}
                                />
                                <button className="slds-button slds-button_brand full-width" disabled={this.state.componentName ? false : true}
                                    onClick={this.applyComponentNameToAll}>Apply to All</button>
                                {
                                    this.state.isRuleApplied ? <AppliedRuleGridComponent ruleObject={ruleObject} toggleModalVisibility={this.toggleRuleModalVisibility} deleteRule={this.deleteRule} /> : <button className="slds-button slds-button_brand full-width slds-m-bottom_small"
                                        onClick={() => { this.toggleRuleModalVisibility(); }}>Add Rule</button>
                                }
                                <button className="slds-button slds-button_brand full-width" disabled={!this.state.isFormValid}
                                    onClick={this.updateStandardAction}>{ruleObject && ruleObject.hasOwnProperty('isActionSaved') && ruleObject.isActionSaved ? `Update Standard Action` : `Save Standard Action`}</button>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    this.state.isApplyRuleModalVisisble && <GridHeaderStdVisibilityRuletModal
                        ruleObject={ruleObject}
                        selectedTemplateName={this.props.selectedTemplateName}
                        toggleModalVisibility={this.toggleRuleModalVisibility}
                        actionType={selectedHeaderAction.name.developerName}
                        updateVisibilityRuleObj={this.updateVisibilityRuleObj}
                    />
                }
            </>
        );
    }

    public updateVisibilityRuleObj = (isRuleApplied: boolean, visibilityRuleObj: any, fields: any, isVisible: string, additionalFieldsArray: any) => {

        this.setState({
            isRuleApplied: isRuleApplied,
            visibilityRuleObj: visibilityRuleObj,
            visibilityRuleFields: fields,
            isVisible,
        }, () => {
            this.isFormValid();
        });
    }

    private extractStoreData = (selectedHeaderAction: any) => {
        let ruleObject = {};
        const ruleElements: any = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const headerActions = gridObj.hasOwnProperty('headerActions') ? ruleElements.gridObject.headerActions : {};
        if (headerActions.hasOwnProperty(selectedHeaderAction.name.developerName)) {
            ruleObject = headerActions[selectedHeaderAction.name.developerName];
        }
        return ruleObject;
    }

    public deleteRule = () => {
        const selectedHeaderAction = CQMasterDataStore.GridObject.selectedHeaderAction;
        this.gridActionsReducer.deleteViewModel(selectedHeaderAction.name.developerName, this.props.selectedTemplateName, 'headerActions');
        this.updateVisibilityRuleObj(false, {}, [], 'false', []);
        let headerFormRules = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'headerFormRules');

        if (headerFormRules.hasOwnProperty(this.state.name)) {
            delete headerFormRules[this.state.name];
        }
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'headerFormRules', headerFormRules);
    }


    /**
     * @private
     * @memberof CQGridControlConfiguration
     */
    private toggleRuleModalVisibility = () => {
        this.setState({
            isApplyRuleModalVisisble: !this.state.isApplyRuleModalVisisble
        });
    }


    /**
 * @private
 * @memberof CustomHeaderActionComponent
 */
    private onComponentNameChange = (addedVal: string) => {
        this.setState({
            componentName: addedVal,
        }, () => {
            this.isFormValid();
        });
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private isFormValid = () => {
        if (!this.state.name || !this.state.label || !this.state.componentName) {
            this.setState({
                isFormValid: false
            });
        } else {
            this.setState({
                isFormValid: true
            });
        }
        if (this.state.isRuleApplied) {
            this.setState({
                isFormValid: true
            }, () => {
                this.updateStandardAction();
            });
        }
    }

    private applyComponentNameToAll = () => {
        CQAppStore.loader.setVisibility(true);
        this.setState({
            isActionSaved: true
        }, () => {
            this.updateAllRuleElements();
            setTimeout(() => { CQAppStore.loader.setVisibility(false); }, 2000);
        });
    }

    private updateStandardAction = () => {
        CQAppStore.loader.setVisibility(true);
        this.setState({
            isActionSaved: true
        }, () => {
            this.updateRuleElements();
            const actionObject: any = ActionMapperController[this.state.actionType].getControllerInstance(this.state);
            this.saveDataToStore(actionObject);
            this.saveToOrderingList(actionObject);
            setTimeout(() => { CQAppStore.loader.setVisibility(false); }, 2000);
        });
    }

    private saveToOrderingList = (actionObject: any) => {
        let orderedHeaderActions = [...CQMasterDataStore.GridObject.orderedHeaderActions];
        const ifExist = orderedHeaderActions.some((orderedAction: any, index: number) => {
            let action = { ...orderedAction };
            if (action.actionJSON.hasOwnProperty('headerActions') && action.actionJSON.headerActions.name === this.state.name) {
                orderedHeaderActions[index] = actionObject;
                return true;
            }
            return false;
        });
        if (!ifExist) {
            orderedHeaderActions.push(actionObject);
        }
        CQMasterDataStore.GridObject.updateGridField('orderedHeaderActions', orderedHeaderActions);
    }

    private saveDataToStore = (actionObject: any) => {
        const outputConfig = CQMasterDataStore.OutputConfig.getStoreData(this.props.selectedTemplateName);
        actionObject && Object.keys(actionObject.actionJSON).length && Object.keys(actionObject.actionJSON).map((objKey: string, index: number) => {
            if (objKey === 'headerFormRules') {
                const headerFormRules = { ...outputConfig.headerFormRules, ...actionObject.actionJSON[objKey] };
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, headerFormRules);
            } else if (objKey === 'headerActions') {
                let headerActions = [...outputConfig.headerActions];
                const ifExist = headerActions.some((action: any, ind: number) => {
                    if (action.name === this.state.name) {
                        headerActions[ind] = { ...actionObject.actionJSON[objKey] };
                        return true;
                    }
                    return false;
                });
                if (!ifExist) {
                    headerActions.push({ ...actionObject.actionJSON[objKey] });
                }
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, headerActions);
            }
            if (Object.keys(actionObject.actionJSON).length < 2 && objKey === 'headerFormRules') {
                let headerActions = [...outputConfig.headerActions];
                headerActions.splice(index, 1);
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'headerActions', headerActions);
            }
        });
    }

    private updateRuleElements = () => {
        const selectedHeaderAction = CQMasterDataStore.GridObject.selectedHeaderAction;
        let ruleElementsObj = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        let gridObj = { ...ruleElementsObj.gridObject };
        let headerActions = { ...gridObj.headerActions };
        headerActions[selectedHeaderAction.name.developerName] = { ...headerActions[selectedHeaderAction.name.developerName], ...this.state };
        gridObj.headerActions = headerActions;
        ruleElementsObj.gridObject = gridObj;
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'ruleElements', ruleElementsObj);
        // store header action rules in FieldRuleElement to avoid being overwritten incase user adds Grid component event rules.
        CQMasterDataStore.RuleElements.addGridObject(ruleElementsObj);
    }

    private updateAllRuleElements = () => {
        let ruleElementsObj = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        let gridObj = { ...ruleElementsObj.gridObject };
        let headerActions = { ...gridObj.headerActions };
        for(const headerAction in headerActions) {
            headerActions[headerAction] = { 
                ...headerActions[headerAction], 
                componentName:this.state.componentName, 
                isFormValid:this.state.isFormValid, 
            }
        }
        gridObj.headerActions = headerActions;
        ruleElementsObj.gridObject = gridObj;
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'ruleElements', ruleElementsObj);
        let orderedHeaderActions:any = [];
        let updatedHeaderActions:any = []
        Object.keys(headerActions).forEach((headerAction:any)=>{
            const actionObject: any = ActionMapperController[this.state.actionType].getControllerInstance(headerActions[headerAction]);
            orderedHeaderActions.push(actionObject)
            updatedHeaderActions.push(actionObject.actionJSON.headerActions)
        })
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'headerActions', updatedHeaderActions);
        CQMasterDataStore.GridObject.updateGridField('orderedHeaderActions', orderedHeaderActions);
    }
}

export const StandardHeaderActionComponentRootComponent = observer(
    StandardHeaderActionComponent
);